<template>
  <el-dialog
    class="finance-order-invoice-modal"
    width="900px"
    title="开票明细"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <data-table :columns="columns" :list="list" max-height="400px" :global-data="{ invoiceOrderId }" />
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import DataTable from '@/components/DataTable'
import { QueryInvoiceDetail } from './services'
export default {
  name: 'OrderInvoiceDetailModal',
  components: { DataTable },
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      list: [],
      invoiceOrderId: 0,
      columns: [
        {
          name: '订单',
          code: 'orderSn',
          flexWidth: 1.6,
          cellComponent: {
            template: '<div :class="{ current: row.current }">{{ row.orderSn }}</div>'
          }
        },
        {
          name: '编号',
          code: 'partCode',
          flexWidth: 1
        },
        {
          name: '名称',
          code: 'partName',
          flexWidth: 1
        },
        {
          name: '开票数量',
          code: 'quantity',
          flexWidth: 0.8
        },
        {
          name: '单价',
          code: 'price',
          flexWidth: 0.8
        },
        {
          name: '优惠',
          code: 'couponAmount',
          flexWidth: 0.8,
          renderFunc (val, row, globalData) {
            if (globalData.invoiceOrderId > 0) {
              return 0
            }
            return ((row.beanExchange / 100 + row.reductionAmount + row.couponAmount) * row.quantity / row.orderQuantity).toFixed(2)
          }
        }
      ]
    }
  },
  methods: {
    init (queryInfo) {
      this.loadData(queryInfo)
      this.invoiceOrderId = queryInfo.invoiceOrderId
      return this.open()
    },
    loadData ({ invoiceId, invoiceOrderId, orderSn }) {
      this.loading = true
      QueryInvoiceDetail(invoiceId).then((resp) => {
        resp.forEach(item => {
          if (invoiceOrderId > 0) {
            item.current = true
            item.orderSn = orderSn
          } else {
            item.current = orderSn === item.orderSn
          }
        })
        this.list = resp
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.finance-order-invoice-modal
  .el-dialog
    width 720px
    .el-dialog__body
      padding-top 0
      td
        padding 4px
        .current
          &:after
            content: '\5f53\524d\8ba2\5355'
            color: #f00
            font-size 12px
            border 1px solid #f00
            padding 1px
            margin-left 2px
</style>
